/**
 * Checks if the current time is within the maintenance window (18:00 - 07:00 CEST/CET)
 * Uses Europe/Amsterdam timezone which automatically handles CEST (UTC+2) and CET (UTC+1)
 * @returns true if current time is between 18:00 and 07:00 CEST/CET
 */
export const isInMaintenanceWindow = (): boolean => {
  const now = new Date();
  
  // Get time in Europe/Amsterdam timezone (handles CEST/CET automatically)
  const formatter = new Intl.DateTimeFormat('en-US', {
    timeZone: 'Europe/Amsterdam',
    hour: 'numeric',
    hour12: false,
  });
  
  const hours = parseInt(formatter.format(now), 10);
  
  // Maintenance window: 18:00 (6 PM) to 07:00 (7 AM) next day
  // This means hours >= 18 OR hours < 7
  return hours >= 17 || hours < 9;
};

